import React from 'react';

import styles from './styles.module.css';

interface RadioButtonProps {
  checked: boolean;
  onChange: () => void;
  label: string;
  disabled?: boolean;
  id?: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  id
}) => {
  return (
    <div className={styles.radioWrapper}>
      <span id={`${label}-radio-label`} className={styles.radioLabel}>{label}</span>
      <div className={styles.radioGroup}>
        <label className={styles.radioInputWrapper}>
          <input
            id={`${label}-radio-input`}
            type="radio"
            name={id}
            value={label}
            checked={checked}
            onChange={onChange}
            className={styles.radioInput}
            disabled={disabled}
          />
          <span id={`${label}-radio-custom`} className={styles.radioCustom}></span>
        </label>
      </div>
    </div>
  );
};

export default RadioButton;
